import clsx from 'clsx';
import type { ThreatTier } from '@/types';
import { getThreatTierLabel, getThreatTierColor } from '@/utils/format';

interface ThreatTierBadgeProps {
  tier: ThreatTier;
  size?: 'sm' | 'md' | 'lg';
  showLabel?: boolean;
}

export function ThreatTierBadge({
  tier,
  size = 'md',
  showLabel = true,
}: ThreatTierBadgeProps) {
  const sizeClasses = {
    sm: 'px-2 py-0.5 text-[10px]',
    md: 'px-2.5 py-1 text-xs',
    lg: 'px-3 py-1.5 text-sm',
  };

  return (
    <span
      className={clsx(
        'inline-flex items-center font-medium tracking-wider',
        getThreatTierColor(tier),
        sizeClasses[size]
      )}
    >
      {showLabel ? `T${tier} ${getThreatTierLabel(tier)}` : `T${tier}`}
    </span>
  );
}
